import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import LockUserIcon from '../../../../assets/icons/lock-user';
import { removeAuthData } from '../../../../store/actions/auth';

import './index.scss';

const VerificationStep: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className="verification-step">
      <LockUserIcon />
      <h3>Дождитесь завершения проверки</h3>
      <p>
        Загруженные вами документы будут проверены Оператором в ближайшее время.
        При возникновении вопросов наши сотрудники свяжутся с вами по указанному
        при регистрации номеру или email.
      </p>
      <Link
        to="/auth"
        onClick={(e) => {
          e.preventDefault();
          dispatch(removeAuthData({}));
          history.push('/auth');
        }}
      >
        Вернуться на страницу входа
      </Link>
    </div>
  );
};

export default VerificationStep;
